import { render } from "./TicketSupportShow.vue?vue&type=template&id=8944952a&scoped=true"
import script from "./TicketSupportShow.vue?vue&type=script&lang=js"
export * from "./TicketSupportShow.vue?vue&type=script&lang=js"

import "./TicketSupportShow.vue?vue&type=style&index=0&id=8944952a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8944952a"]])

export default __exports__